export default "__VITE_ASSET__CtL8LhlU__"